import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import {
  TOGGLE_TAG,
  TAG_TOGGLE,
  TAG_ALL_FETCH,
  TAG_ALL_FETCH_SUCCESS,
  TAG_QUERY_FETCH,
  TAG_QUERY_FETCH_SUCCESS,
  TAG_QUERY_FETCH_FAILURE,
} from '../reducers/booklet-tags.reducer';
import { bookletApi } from '../services';
import { handleError } from './helper';
import { BOOKLET_LIST_FETCH } from '../reducers/booklet-list.reducer';
import { types } from '../consts';
import { BOOKLET_ARCHIVE_FETCH } from '../reducers/booklet-archive.reducer';
import { delay } from 'redux-saga';
import { showNotification } from '../helpers/notification';

function* fetchTagsByQueryRequest({ payload: { query } }) {
  try {
    yield call(delay, 800);
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(bookletApi.fetchTagsList, { query });
    yield put({ type: TAG_QUERY_FETCH_SUCCESS, payload: { data: data.tags } });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: TAG_QUERY_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* fetchAllTagsRequest() {
  try {
    yield put({ type: LOADING_DATA_START });
    const tags = yield select(getCurrentTags);

    const { data } = tags.length
      ? yield call(bookletApi.fetchRelatedTagsList, { tags })
      : yield call(bookletApi.fetchAllTagsList);

    //if no tags in response add current selected for user to be able to un select them
    if (!data.tags.length) {
      data.tags = tags;
    }

    yield put({ type: TAG_ALL_FETCH_SUCCESS, payload: { data: data.tags } });
  } catch (error) {
    const message = yield* handleError(error, 'Fetching tags failed.');
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* toggleTagRequest({ payload: { tag, type } }) {
  try {
    yield put({ type: TOGGLE_TAG, payload: { tag } });
    yield put({ type: TAG_ALL_FETCH });

    switch (type) {
      case types.BOOKLET:
        yield put({ type: BOOKLET_LIST_FETCH });
        break;
      case types.ARCHIVE:
        yield put({ type: BOOKLET_ARCHIVE_FETCH });
        break;
      default:
        break;
    }
  } catch (error) {
    const message = yield* handleError(error, 'Toggle tag failed.');
    showNotification(message);
  }
}

const getCurrentTags = state => state.bookletTags.currentTags;

export function* fetchTagsByQuery() {
  yield takeLatest(TAG_QUERY_FETCH, fetchTagsByQueryRequest);
}

export function* toggleTag() {
  yield takeLatest(TAG_TOGGLE, toggleTagRequest);
}

export function* fetchAllTags() {
  yield takeLatest(TAG_ALL_FETCH, fetchAllTagsRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/booklet-tags.saga.js